import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import '@suezenv/react-theme-components/assets/css/main.css';
import AppRouter from './App';
import * as serviceWorker from './serviceWorker';
import { history } from './store';
import './index.scss';
import './i18n';
ReactDOM.render(<AppRouter history={history} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
